import Homepage from "./pages/homepage/Homepage";
import './App.css'

function App() {
  return (
    <div className="App">
      <Homepage/>
    </div>
  );
}

export default App;
